import React from 'react';
import dynamic from 'next/dynamic';
const Select = dynamic(() => import('react-select'), { ssr: false });


const options = [
    { value: 'Por favor seleccione', label: 'Por favor Seleccione' },
];

export default function EmptyField({style}) {
    const customStyle = {
        dropdownIndicator: (base, state) => ({
            ...base,
            transition: 'all .2s ease',
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null
        }),
        menu: (base, state) => ({
            height: "55px",
            zIndex: 1000, // Add zIndex to ensure the dropdown appears on top
            position: 'absolute', // This helps to avoid affecting the layout below
            borderRadius: "10px"
        }),
        control: (base, state) => ({
            ...base,
            height: style ? style.height : "45px",
            borderColor: style ? style.borderColor : "#9EA3A5",
            boxShadow: style ? "none" : "",
            borderRadius: style ? style.rounded : "",
            '&:hover': {
                borderColor: style ? "none" : "", // Remove hover border
            },
            '&:focus': {
                borderColor: "none"
            }
        })
        // Add more styles as needed
    };
    return (
        <div className="w-full">
            <label
                className="text-sm font-bold leading-7 text-[#111]"
            >
            </label>
            <Select
                options={options}
                styles={customStyle}
                placeholder="Seleccione"
                required
            />
        </div>
    );
}
